export enum DateFormats {
  Date = 'dd/MM/yyyy',
  Time = 'HH:mm',
  FullTime = 'HH:mm:ss',
  DateTime = 'dd/MM/yyyy - HH:mm',
  DateFullTime = 'dd/MM/yyyy - HH:mm:ss',
  ISOFile = "yyyy-MM-dd'T'HH-mm-ss",
  ISODate = 'yyyy-MM-dd',
}
